import { DeleteButton, EditButton } from "@/components/IconButton/variants";

import PropTypes from "prop-types";
import React from "react";

function Actions({
  row,
  handleOnClickDelete,
  handleOnClickEdit,
  enableDelete = true,
}) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      <EditButton onClick={() => handleOnClickEdit(row.original)} />
      {enableDelete && (
        <DeleteButton onClick={() => handleOnClickDelete(row.original)} />
      )}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.func.isRequired,
  handleOnChangeStatus: PropTypes.func.isRequired,
  handleOnClickEdit: PropTypes.func.isRequired,
};

export default React.memo(Actions);
